import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { formatBalance } from '@homeplay/utils';

export const useNotification = () => {
  const depositNotification = useCallback(
    (amount) =>
      toast.info(
        () => (
          <div>
            You have deposited{' '}
            <span style={{ color: 'gold', fontWeight: 700 }}>
              {formatBalance(amount)}
            </span>{' '}
            to your account
          </div>
        ),
        {
          icon: () => '🪙',
          className: 'app-toast-success',
        }
      ),
    []
  );

  const depositInProgressNotification = useCallback(
    () =>
      toast.info('Voucher accepted, crediting is in progress', {
        icon: () => '🪙',
      }),
    []
  );

  const withdrawalNotification = useCallback(
    (amount) =>
      toast.info(
        () => (
          <div>
            You have withdrew{' '}
            <span style={{ color: 'gold', fontWeight: 700 }}>
              {formatBalance(amount)}
            </span>{' '}
            from your account
          </div>
        ),
        {
          className: 'app-toast-success',
        }
      ),
    []
  );

  const editPhoneNotification = useCallback(
    () =>
      toast.info('Success! Your phone number has been changed', {
        className: 'app-toast-success',
      }),
    []
  );

  const operationCancelledNotification = useCallback(
    () => toast.warn('Operation canceled'),
    []
  );

  const errorNotification = useCallback(
    () => toast.error('Something went wrong'),
    []
  );

  const jackpotNotification = useCallback(
    (type, amount, winner, opts = {}) =>
      toast.success(
        () => (
          <div>
            <strong>{type?.toUpperCase()} Jackpot won by {winner}</strong>
            <br />
            <span style={{ color: 'gold', fontWeight: 700, fontSize: '1.2em' }}>
              {formatBalance(amount)}
            </span>
          </div>
        ),
        {
          className: `app-toast-success jp-won-toast jp-${String(type || '').toLowerCase()}-toast`,
          containerId: opts.containerId,
          hideProgressBar: true,
        }
      ),
    []
  );

  const bonusCampaignStartedNotification = useCallback(
    (onClick) =>
      toast.info(
        () => (
          <div>
            You have just started the bonus.{' '}
            <span style={{ color: 'gold', textDecoration: 'underline' }}>
              See details
            </span>
          </div>
        ),
        { icon: () => '🎁', onClick }
      ),
    []
  );

  const bonusCampaignActivatedNotification = useCallback(
    (amount) =>
      toast.info(
        () => (
          <div>
            Your deposit was successful. Bonus{' '}
            <span style={{ color: 'gold', fontWeight: 700 }}>
              {formatBalance(amount)}
            </span>{' '}
            has been credited to your bonus account. Enjoy!
          </div>
        ),
        { icon: () => '🎁', className: 'app-toast-success' }
      ),
    []
  );

  const bonusCampaignCompletedNotification = useCallback(
    (amount) =>
      toast.info(
        () => (
          <div>
            You have wagered the bonus and{' '}
            <span style={{ color: 'gold', fontWeight: 700 }}>
              {formatBalance(amount)}
            </span>{' '}
            has been credited to your cash balance
          </div>
        ),
        { icon: () => '🪙', className: 'app-toast-success' }
      ),
    []
  );

  return {
    depositNotification,
    depositInProgressNotification,
    withdrawalNotification,
    editPhoneNotification,
    operationCancelledNotification,
    errorNotification,
    jackpotNotification,
    bonusCampaignStartedNotification,
    bonusCampaignActivatedNotification,
    bonusCampaignCompletedNotification,
  };
};
